<template>
    <div class="schedule-component">
        <div class="mb-4">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <a :href=route_back>Реестр релизов</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Добавить релиз</li>
                </ol>
            </nav>
        </div>

        <div class="two-col-container">
            <div class="left-col">
                <div class="schedule-component__select mb-4">
                    <div class="form-label">Клиент <span class="color-red">*</span></div>
                    <v-select class="select"
                              v-model="client"
                              :items="clients"
                              @update:modelValue="onChangeClient"
                              @update:menu="$removeFocus"
                              @click:clear="$removeFocus"
                              @click:control="$removeFocus"
                              item-title="name"
                              item-value="id"
                              variant="outlined"
                              color="primary"
                              density="compact"
                              clearable>
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>
                </div>

                <div class="schedule-component__select mb-4">
                    <div class="form-label">Бренд <span class="color-red">*</span></div>
                    <v-select class="select"
                              :disabled="!client"
                              v-model="brand"
                              :items="brands"
                              @update:modelValue="onChangeBrand"
                              @update:menu="$removeFocus"
                              @click:clear="$removeFocus"
                              @click:control="$removeFocus"
                              item-title="name"
                              item-value="id"
                              variant="outlined"
                              color="primary"
                              density="compact"
                              clearable>
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>
                </div>

                <div class="schedule-component__select mb-4">
                    <div class="form-label">Тип устройства <span class="color-red">*</span></div>
                    <v-select class="select"
                              :disabled="!client || !brand"
                              v-model="deviceType"
                              :items="deviceTypes"
                              @update:modelValue="onChangeDeviceType"
                              @update:menu="$removeFocus"
                              @click:clear="$removeFocus"
                              @click:control="$removeFocus"
                              item-title="name"
                              item-value="id"
                              variant="outlined"
                              color="primary"
                              density="compact"
                              clearable>
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>
                </div>

                <div class="mb-4">
                    <div class="form-label">Тип обновления <span class="color-red">*</span></div>
                    <v-select class="select"
                              v-model="deviceSoftwareType"
                              :items="deviceSoftwareTypes"
                              @update:modelValue="onChangeDeviceSoftwareType"
                              item-title="name"
                              item-value="id"
                              variant="outlined"
                              color="primary"
                              density="compact"
                              clearable
                              @update:menu="$removeFocus"
                              @click:clear="$removeFocus"
                              @click:control="$removeFocus">
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>
                </div>

                <div class="schedule-component__select mb-4">
                    <div class="form-label">Операционная система <span class="color-red">*</span></div>
                    <v-select class="select"
                              v-model="deviceOperatingSystem"
                              :items="deviceOperatingSystems"
                              @update:modelValue="onChangeDeviceOperatingSystem"
                              @update:menu="$removeFocus"
                              @click:clear="$removeFocus"
                              @click:control="$removeFocus"
                              item-title="name"
                              item-value="id"
                              variant="outlined"
                              color="primary"
                              density="compact"
                              clearable>
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>
                </div>

                <div class="schedule-component__select mb-4">
                    <div class="form-label">Версия <span class="color-red">*</span></div>
                    <v-select class="select"
                              :disabled="!client || !brand || !deviceOperatingSystem || !deviceType"
                              v-model="versionId"
                              :items="versions"
                              item-title="full_version"
                              item-value="id"
                              variant="outlined"
                              color="primary"
                              density="compact"
                              clearable
                              @update:menu="$removeFocus"
                              @click:clear="$removeFocus"
                              @click:control="$removeFocus">
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>
                </div>

                <div class="schedule-component__select mb-4">
                    <label class="form-label">Дата релиза <span class="color-red">*</span></label>
                    <input v-model="releaseDate" type="date" class="form-control" required>
                </div>

                <div style="max-width: 510px" class="mb-4">
                    <div class="tabs">
                        <div class="tabs__log-ctrls">
                            <button @click="setSelectedTabId"
                                    :class="{'selected': selectedTabId === 'device'}"
                                    id="device"
                                    class="reset-btn tabs__log-ctrl">
                                Устройства
                            </button>
                            <button @click="setSelectedTabId"
                                    :class="{'selected': selectedTabId === 'deviceGroups'}"
                                    id="deviceGroups"
                                    class="reset-btn tabs__log-ctrl">
                                Группы устройств
                            </button>
                            <button @click="setSelectedTabId"
                                    :class="{'selected': selectedTabId === 'locations'}"
                                    id="locations"
                                    class="reset-btn tabs__log-ctrl">
                                Список аптек
                            </button>
                            <button @click="setSelectedTabId"
                                    :class="{'selected': selectedTabId === 'regions'}"
                                    id="regions"
                                    class="reset-btn tabs__log-ctrl">
                                Регионы
                            </button>
                            <span class="color-red">*</span>
                        </div>
                    </div>

                    <template v-if="selectedTabId === 'device'">
                        <select-back-searchable-element
                            v-if="client && brand && deviceType"
                            @getItems="loadDevices"
                            @syncItems="syncDevices"
                            :loaded_items="devices_founded"
                            :picked_items="selectedDevices"
                            :pages="devices_pages">
                        </select-back-searchable-element>
                    </template>

                    <template v-if="selectedTabId === 'deviceGroups'">
                        <div class="mb-4">
                            <v-select class="select"
                                      :disabled="!client && !brand && !deviceType"
                                      v-model="group"
                                      :items="groups"
                                      item-title="name"
                                      item-value="id"
                                      variant="outlined"
                                      color="primary"
                                      density="compact"
                                      multiple
                                      clearable
                                      @update:menu="$removeFocus"
                                      @click:clear="$removeFocus"
                                      @click:control="$removeFocus">
                                <template #no-data>
                                    <v-list-item>
                                        <span>Данные не найдены</span>
                                    </v-list-item>
                                </template>
                            </v-select>
                        </div>
                    </template>

                    <template v-if="selectedTabId === 'locations'">
                        <div class="mb-4">
                            <input
                                v-bind:disabled="!brand && !deviceType"
                                v-model="locations"
                                type="text"
                                class="form-control"
                                id="locations"
                                placeholder="Номера аптек через пробел 77-008 77-1500">
                        </div>
                    </template>

                    <template v-if="selectedTabId === 'regions'">
                        <v-select class="select"
                                  :disabled="!brand && !deviceType"
                                  v-model="region"
                                  :items="regions"
                                  item-title="name"
                                  item-value="id"
                                  variant="outlined"
                                  color="primary"
                                  density="compact"
                                  multiple
                                  clearable
                                  @update:menu="$removeFocus"
                                  @click:clear="$removeFocus"
                                  @click:control="$removeFocus">
                            <template #no-data>
                                <v-list-item>
                                    <span>Данные не найдены</span>
                                </v-list-item>
                            </template>
                        </v-select>
                    </template>
                </div>

                <div class="schedule-component__text-input mb-4">
                    <div class="form-label">Описание <span class="color-red">*</span></div>
                    <textarea cols="30" rows="5" class="form-control" v-model="description" placeholder="Полное описание релиза" required></textarea>
                </div>

                <div class="form-check mb-4">
                    <label for="create-unscheduled-release" class="form-check-label">
                        <span>Внеочередное обновление</span>
                        <input id="create-unscheduled-release" class="form-check-input" type="checkbox" v-model="isEmergencyRelease">
                    </label>

                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <title>Обновление будет установлено сразу после загрузки</title>
                        <path d="M10 7.5H10.0083M9.16667 10H10V13.3333H10.8333M2.5 10C2.5 10.9849 2.69399 11.9602 3.0709 12.8701C3.44781 13.7801 4.00026 14.6069 4.6967 15.3033C5.39314 15.9997 6.21993 16.5522 7.12987 16.9291C8.03982 17.306 9.01509 17.5 10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 8.01088 16.7098 6.10322 15.3033 4.6967C13.8968 3.29018 11.9891 2.5 10 2.5C8.01088 2.5 6.10322 3.29018 4.6967 4.6967C3.29018 6.10322 2.5 8.01088 2.5 10Z" stroke="#E33535" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div class="schedule-component__btns">
                    <ConfirmBtn :class="'btn btn-lg btn-primary'" :text="'Сохранить'" @btnClick="save"/>
                    <a type="button" class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
                </div>
            </div>

            <Transition name="fade">
                <div v-if="showSelectedDevices" class="right-col">
                    <SelectedDevices
                        :devicesFounded="devices_founded"
                        v-model:addedDevicesIds="selectedDevices"
                        v-model:groupIds="group"
                        v-model:locationNumbers="locations"
                        v-model:regionIds="region"
                        @stateChange="handleSelectedDevicesState"
                    />
                </div>
            </Transition>
        </div>
    </div>

    <Alert />
</template>

<script>
import Release from '../../../../models/Release';
import SelectBackSearchableElement from '../../../../elements/SelectBackSearchableElement.vue';
import axios from 'axios';
import Alert from '../../../alerts/Alert.vue';
import { mapMutations, mapState } from 'vuex/dist/vuex.cjs.js';
import ConfirmBtn from '../../../../elements/ConfirmBtn.vue';
import SelectedDevices from '../../../../elements/SelectedDevices.vue';

export default {
    name: 'ReleaseAddComponent',
    components: { Alert, SelectBackSearchableElement, ConfirmBtn, SelectedDevices },

    props: {
        route_back: String,
        route_store: String,
        route_brands: String,
        route_clients: String,
        route_device_type_options: String,
        route_get_regions: String,
        route_devices_search: String,
        route_groups_by_device_type: String,
        route_operating_systems: String,
        route_release_versions_search: String,
        route_device_software_types: String,
    },

    data() {
        return {
            release: new Release({
                route_client_search: this.route_clients,
                route_brand_search: this.route_brands,
                route_devices_search: this.route_devices_search,
                route_groups_by_device_type: this.route_groups_by_device_type,
            }),
            client: null,
            clients: [],

            brand: null,
            brands: [],

            deviceType: null,
            deviceTypes: [],

            deviceSoftwareType: null,
            deviceSoftwareTypes: [],

            selectedTabId: 'device',

            versionId: null,
            versions: [],

            isEmergencyRelease: 0,
            description: '',

            releaseDate: null,

            deviceOperatingSystem: null,
            deviceOperatingSystems: [],

            devices: [],
            devices_founded: [],
            device_ids: [],
            device_ids_new: [],
            selectedDevices: [],
            devices_pages: 1,

            region: [],
            regions: [],

            group: [],
            groups: [],

            locations: '',
            selectedItems: [],
            // isButtonDisabled: false

            showSelectedDevices: false,

            releaseMetadata: null,
        }
    },
    computed: {
        ...mapState('selectedDevices', ['selectedDevicesCount']),
        devicesSelected() {
            return !!(this.selectedDevices.length || this.group.length || this.locations.length || this.region.length);
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        setSelectedTabId(e) {
            this.selectedTabId = e.target.id;
        },
        removeItem (index) {
            this.selectedItems.splice(index, 1);
        },
        getBrands: async function (clientId) {
            let brands = await this.release.brands({
                client_id: clientId
            });
            this.brands = brands.items;
        },
        getVersions: async function (clientId, brandId, deviceTypeId, deviceOsId, deviceSoftwareTypeId) {
            if (clientId && brandId && deviceTypeId && deviceOsId && deviceSoftwareTypeId) {
                let response = await axios.get(
                    this.route_release_versions_search, {
                        params: {
                            client_id: clientId,
                            brand_id: brandId,
                            device_type_id: deviceTypeId,
                            device_software_type_id: deviceSoftwareTypeId,
                            device_operating_system_id: deviceOsId,
                        }
                    });

                this.versions = response.data.data;
            }
        },
        getDeviceSoftwareTypes: async function () {
            const response = await axios.get(this.route_device_software_types);
            this.deviceSoftwareTypes = response.data.data;
        },
        getClients: async function () {
            let clients = await this.release.clients();
            this.clients = clients.items;
        },
        getDeviceTypeOptions: async function() {
            const response = await axios.get(this.route_device_type_options);
            this.deviceTypes = response.data.data;
        },
        getDeviceOperatingSystems: async function () {
            const response = await axios.get(this.route_operating_systems);
            this.deviceOperatingSystems = response.data.data;
        },
        onChangeClient: async function(clientId) {
            await this.getBrands(clientId);
            await this.getVersions(clientId, this.brand, this.deviceType, this.deviceOperatingSystem, this.deviceSoftwareType);
            this.brand = null;
            this.versionId = null;
        },
        onChangeBrand: async function (brandId) {
            this.devices = [];
            this.selectedDevices = [];
            await this.getVersions(this.client, brandId, this.deviceType, this.deviceOperatingSystem, this.deviceSoftwareType);
            this.deviceType = null;
            this.versionId = null;
        },
        onChangeDeviceType: async function (deviceTypeId) {
            this.devices = [];
            this.selectedDevices = [];
            await this.loadDevices();
            await this.getGroups();
            await this.getVersions(this.client, this.brand, deviceTypeId, this.deviceOperatingSystem, this.deviceSoftwareType);
            this.versionId = null;
        },
        onChangeDeviceOperatingSystem: async function (osId) {
            this.devices = [];
            this.selectedDevices = [];
            await this.loadDevices();
            await this.getGroups();
            await this.getVersions(this.client, this.brand, this.deviceType, osId, this.deviceSoftwareType);
            this.versionId = null;
        },
        onChangeDeviceSoftwareType: async function (softwareTypeId) {
            this.devices = [];
            this.selectedDevices = [];
            await this.getVersions(this.client, this.brand, this.deviceType, this.deviceOperatingSystem, softwareTypeId);
            this.versionId = null;
        },
        syncDevices: function (devices) {
            this.selectedDevices = devices;
            this.devices_changed = true;
        },
        loadDevices: async function (search, limit, page) {
            let data = await this.release.devices({
                search: search,
                limit: 99999,
                page: page,
                client_id: this.client,
                brand_id: this.brand,
                device_type_id: this.deviceType,
                device_operating_system_id: this.deviceOperatingSystem
            });
            this.devices_founded = data.items;
            this.devices_pages = data.pages;
        },
        getRegions: async function () {
            let data = await axios.get(this.route_get_regions, {
                params: {
                    limit: 9999
                }
            });
            this.regions = data.data.items;
        },
        getGroups: async function () {
            let data = await this.release.getDevicesGroupsByDeviceType({
                client_id: this.client,
                brand_id: this.brand,
                device_type_id: this.deviceType,
                device_os_id: this.deviceOperatingSystem
            });
            this.groups = data.items;
        },
        save: async function () {
            this.isButtonDisabled = true;
            if (this.client === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберете клиента!' });
                this.toggleLoading();
                return;
            }

            if (this.brand === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберете бренд!' });
                this.toggleLoading();
                return;
            }

            if (this.deviceType === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберете тип устройства!' });
                this.toggleLoading();
                return;
            }

            if (this.deviceSoftwareType === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберете тип обновления!' });
                this.toggleLoading();
                return;
            }

            if (this.versionId === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберете версию!' });
                this.toggleLoading();
                return;
            }

            if (this.releaseDate === null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Выберете дату релиза!' });
                this.toggleLoading();
                return;
            }

            if (this.description === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Добавьте описание релиза!' });
                this.toggleLoading();
                return;
            }

            if (this.description.length < 10) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Слишком короткое описание. Минимальное количество символов не менее 10.' });
                this.toggleLoading();
                return;
            }

            if (!this.selectedDevicesCount.length) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Добавьте хотя бы одно устройство' });
                this.toggleLoading();
                return;
            }

            let response = await axios.post(
                this.route_store,
                {
                    device_software_version_id: this.versionId,
                    scheduled_release_date: this.releaseDate,
                    description: this.description,
                    is_emergency_release: this.isEmergencyRelease,
                    release_metadata: this.releaseMetadata,
                    device_ids: this.selectedDevices.map(el => el.id),
                    locations: this.locations,
                    regions: this.region,
                    groups: this.group,
                }
            );

            if (response.data.data) {
                window.location.href = this.route_back;
            } else {
                this.addAlert({ type: 'error', title: 'Ошибка', text: response.data.message });
                this.toggleLoading();
            }
        },
        handleSelectedDevicesState(state) {
            this.showSelectedDevices = state;
        }
    },
    watch: {
        devicesSelected: {
            handler(val) {
                if (val) {
                    this.showSelectedDevices = true;
                }
            },
            immediate: true
        },
    },
    mounted () {
        this.getBrands();
        this.getClients();
        this.getDeviceTypeOptions();
        this.getRegions();
        this.getDeviceOperatingSystems();
        this.getDeviceSoftwareTypes();
    }
}
</script>

<style scoped lang="scss">
.title-block {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    &__btns {
        margin-left: auto;
        display: flex;
        gap: 6px;
    }
}
.page-label {
    font-size: 18px;
    font-weight: 600;
}
.schedule-component {
    &__select {
        max-width: 400px;
    }
    &__text-input {
        @extend.schedule-component__select;
    }
    &__btns {
        display: flex;
        gap: 16px;
        button {
            width: 214px;
        }
    }
    &__selected-items {
        display: flex;
        flex-direction: column;
        max-height: 170px;
        max-width: 710px;
        overflow-y: auto;
        gap: 10px;
        .selected-item {
            display: flex;
            align-items: center;
            justify-content: center;
            &__text {
                font-size: 16px;
                font-weight: 400;
                color: #0678F4;
            }
            &__icon {
                margin-left: auto;
                margin-right: 6px;
                min-height: 20px;
                min-width: 20px;
                cursor: pointer;
                transition: 0.2s;
                &:hover {
                    color: red;
                    transition: 0.2s;
                }
            }
        }
    }
}
.tabs {
    &__log-ctls {
        gap: 10px !important;
    }
}
.form-check {
    display: flex;
    gap: 8px;
    align-items: center;
}
</style>
